export enum VehicleInsurancePremiumPeriodEnum {
	MONTHLY = 'monthly',
	YEARLY = 'yearly',
}
